import React from "react";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import '../components/css/BlogStyle.css';
import blog1 from '../components/images/vigyan-vriksh-blog-img.jpg';

function Blog(){
    return(
        <>
            <HeaderTop />
            <Navbar />
            <section className="page-banner">
                <div className="container">
                    <div className="banner-content">
                        <h1 className="fw-bold">Blog Banner</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Blog Banner</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <div class="container my-5">
                <div class="row g-4">
                    <div class="col-lg-9">
                        <div class="row g-4">
                            <div class="col-md-6 mb-5">
                                <div class="blog-card">
                                    <img src={blog1} class="img-fluid w-100" alt="blog1" />
                                    <div class="mt-3">
                                        {/* <div class="blog-meta mb-2">
                                            <i class="bi bi-calendar-event"></i> April 2024 &nbsp; | &nbsp; <i class="bi bi-chat-dots"></i> 4 Comments
                                        </div> */}
                                        <h5>UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</h5>
                                        <p>uppsc.up.nic.in Uttar Pradesh Public Service Commission (UPPSC) UP GIC Lecturer Recruitment 2025, ....</p>
                                        <Link to="/Upgiclecturerrecruitment2025" class="btn btn-read">Read More</Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 mb-5">
                                <div class="blog-card">
                                    <img src={blog1} class="img-fluid w-100" alt="blog1" />
                                    <div class="mt-3">
                                        {/* <div class="blog-meta mb-2">
                                            <i class="bi bi-calendar-event"></i> April 2024 &nbsp; | &nbsp; <i class="bi bi-chat-dots"></i> 4 Comments
                                        </div> */}
                                        <h5>RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</h5>
                                        <p>rpsc.rajasthan.gov.in Rajasthan Public Service Commission (RPSC) RPSC School Lecturer Vacancy 2025 .....</p>
                                        <Link to="/RPSCSchoollecturer2025" class="btn btn-read">Read More</Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 mb-5">
                                <div class="blog-card">
                                    <img src={blog1} class="img-fluid w-100" alt="blog1" />
                                    <div class="mt-3">
                                        {/* <div class="blog-meta mb-2">
                                            <i class="bi bi-calendar-event"></i> April 2024 &nbsp; | &nbsp; <i class="bi bi-chat-dots"></i> 4 Comments
                                        </div> */}
                                        <h5>GATE Examination 2026</h5>
                                        <p>GATE Examination 2026 : Here You Can Get All The Current And Upcoming Information Related ....</p>
                                        <Link to="/GATEExamination2026" class="btn btn-read">Read More</Link>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 mb-5">
                                <div class="blog-card">
                                    <img src={blog1} class="img-fluid w-100" alt="blog1" />
                                    <div class="mt-3">
                                        {/* <div class="blog-meta mb-2">
                                            <i class="bi bi-calendar-event"></i> April 2024 &nbsp; | &nbsp; <i class="bi bi-chat-dots"></i> 4 Comments
                                        </div> */}
                                        <h5>Bihar BPSC AES Recruitment 2025</h5>
                                        <p>Bihar Public Service Commission (BPSC), The notification for the recruitment of Assistant Environmental Scientist (AES) Recruitment ....</p>
                                        <Link to="/BiharBPSCAESRecruitment2025" class="btn btn-read">Read More</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="sidebar-box">
                            <h5>Search</h5>
                            <div class="input-group mt-3">
                                <input type="text" class="form-control" placeholder="Enter Keyword" />
                                <button class="btn btn-light"><i class="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div class="sidebar-box">
                            <h5>Recent Posts</h5>
                            <div class="recent-post mt-3">
                                <ul className="list-unstyled">
                                    <li><Link to="/Upgiclecturerrecruitment2025">UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</Link></li>
                                    <li><Link to="/RPSCSchoollecturer2025">RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</Link></li>
                                    <li><Link to="/GATEExamination2026">GATE Examination 2026</Link></li>
                                    <li><Link to="/BiharBPSCAESRecruitment2025">Read More</Link></li>
                                </ul>
                                <div>
                                    <p class="mb-0"></p>
                                </div>
                            </div>
                        </div>
                        {/* <div class="sidebar-box">
                            <h5>Instagram</h5>
                            <div className="row">
                                <div class="col-md-4 mt-3">
                                    <img src="https://livi.wpengine.com/wp-content/uploads/2024/10/h2.jpg" style={{ width: "100%" }} alt="thumb" />
                                </div>
                                <div class="col-md-4 mt-3">
                                    <img src="https://livi.wpengine.com/wp-content/uploads/2024/10/h2.jpg" style={{ width: "100%" }} alt="thumb" />
                                </div>
                                <div class="col-md-4 mt-3">
                                    <img src="https://livi.wpengine.com/wp-content/uploads/2024/10/h2.jpg" style={{ width: "100%" }} alt="thumb" />
                                </div>
                                <div class="col-md-4 mt-3">
                                    <img src="https://livi.wpengine.com/wp-content/uploads/2024/10/h2.jpg" style={{ width: "100%" }} alt="thumb" />
                                </div>
                                <div class="col-md-4 mt-3">
                                    <img src="https://livi.wpengine.com/wp-content/uploads/2024/10/h2.jpg" style={{ width: "100%" }} alt="thumb" />
                                </div>
                                <div class="col-md-4 mt-3">
                                    <img src="https://livi.wpengine.com/wp-content/uploads/2024/10/h2.jpg" style={{ width: "100%" }} alt="thumb" />
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
export default Blog;